<template>
  <text-input
    :autofocus="false"
    :label-text="labelText"
    :placeholder="placeholder"
    :value="value"
    :onInput="onInputInternal"
    :inputType="'email'"
    :error="error"
    :error-message="emailErrorLabel" />
</template>

<script>
import _ from 'lodash';
import TextInput from './TextInput.vue';

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w\w+$/;

/*
@Deprecated
 */
export default {
  name: 'EmailInput',
  components: {
    TextInput,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    onInput: {
      type: Function,
      required: true,
    },
    onError: {
      type: Function,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    labelText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    emailErrorLabel() {
      return this.error ? 'האימייל שהזנת לא תקין' : undefined;
    },
  },
  methods: {
    async onInputInternal(value) {
      await this.clearEmailError();
      await this.onInput(value);
      await this.calcEmailError();
    },
    async clearEmailError() {
      this.error = false;
      await this.onError(false);
    },
    async calcEmailError() {
      if (_.isEmpty(this.value)) {
        this.error = false;
      } else {
        this.error = !emailRegex.test(this.value);
      }
      await this.onError(this.error);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
